import { gql } from "@apollo/client";

export const CREATE_USER_CUSTOMER = gql`
  mutation CreateUserCustomerMutation($input: CreateUserCustomerInput!) {
    createUserCustomer(input: $input) {
      ok
      error
      id
    }
  }
`;

export const REMOVE_USER_CUSTOMER = gql`
  mutation RemoveUserCustomerMutation($id: Int!) {
    removeUserCustomer(id: $id) {
      ok
      error
    }
  }
`;

export const USER_CUSTOMER = gql`
  query UserCustomerQuery($id: Int!) {
    userCustomer(id: $id) {
      ok
      error
      result {
        id
        userId
        user {
          id
          firstname
        }
        customerId
        customer {
          id
          name
        }
      }
    }
  }
`;

export const USER_CUSTOMERS = gql`
  query UserCustomersQuery($where: UserCustomersFiltersInput!) {
    userCustomers(where: $where) {
      ok
      error
      results {
        id
        userId
        customerId
      }
    }
  }
`;
